module.exports = __webpack_public_path__ + "static/autocomplete-filters-793170cc6414b6072bf33465c685c16f.png";